import { Component, OnInit, ViewChildren, QueryList, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { DataSource } from '@angular/cdk/table';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { Constants } from '../../../../_utils/Constants';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { FormBuilder, Validators, FormGroup, NgForm } from '@angular/forms';
import { formatDate } from '@angular/common';
import { saveAs as importedSaveAs } from "file-saver";
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalPromptComponent } from '../../../../_helpers/Modals/prompt/modal.prompt';
import { Router, ActivatedRoute } from '@angular/router';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { APIEntityService } from '../../_services/entity/API-entity';
import { PromptPETMBindingModalData } from 'src/app/_helpers/Modals/ModalData';
import { PETMBindingDialogComponent } from 'src/app/_helpers/Modals/petmbinding-dialog/petmbinding-dialog.component';


const now = new Date();
const time_today = now.getTime();
const formatTime = formatDate(time_today, 'HH:mm', 'en-US', '+0530');
const currentdat = formatDate(now, 'dd-MM-yyyy', 'en-US', '+0530');
console.log("formatTime -- : ", formatTime);

export interface DialogData {
  setValue: string,
  setRole: string
}
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-petmbinding-tmtatdlist',
  templateUrl: './petmbinding-tmtatdlist.component.html',
  styleUrls: ['./petmbinding-tmtatdlist.component.css']

})

export class PETMBindingTMTATDListComponent implements OnInit {

  maxDate: Date = new Date();
  mindate = new Date(now.getFullYear(), 0, 1);
  maxdate = new Date(now.getFullYear(), now.getMonth(), now.getDate())

  dataSource: MatTableDataSource<any>;

  PETMBindingForm: FormGroup;
  actionForm: FormGroup;
  public modalRef: BsModalRef;
  form1: any = {};
  data: any = {};
  filterData: any;
  pageNo: number = 1;
  pageSize: number = 5;
  length: number = 5;
  Param: any;
  fetchedData: any;
  noRecord: any;
  afterApply: boolean = false;

  Status: any;
  public queryData: any = { sts: "" };
  searchError: boolean = false;
  showStatusDropdown: boolean = false;
  entityName: any;
  entityId: any;

  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChild('t1Sort') t1Sort: MatSort;

  dataSubject = new BehaviorSubject<any[]>([]);


  displayedColumns: string[] = ['URN', 'ChainID', 'RequestorID', 'RequestorName', 'RespondantID','RespondantName', 'Role','ActionDt', 'ChainStatus','SequenceSts', 'Action'];


  constructor(
    private fb: FormBuilder,
    private $modal: $ModalManagerService,
    private db: $DBManagerService,
    private es: APIEntityService,
    private _route: ActivatedRoute,
    public dialog: MatDialog,
    private $: $BroadcastManagerService,
    private modalService: BsModalService,
    private router: Router) {
    this._route.params.subscribe((params) => {

      this.entityName = this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_NAME);
      this.entityId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
    });
  }


  ngOnInit() {    


    this.maxDate.setDate(new Date().getDate());


    this.data = {
      "EntityID": this.entityId
    }

    this.fetchpetmbindinglist(this.data)

  }

  get f() { return this.PETMBindingForm.controls; }

  onChangeDataSource(value) {

    this.dataSource = new MatTableDataSource(value.message);
    //console.log("------------------values" + this.dataSource);
    this.dataSource.paginator = this.paginator.toArray()[0];
    // console.log("values" + value);
    this.dataSource.sort = this.t1Sort;
    this.noRecord = this.dataSource.connect().pipe(map(data => data.length === 0));


  }

   searchRequired: boolean = false;
  errorSerch() {
    if (this.form1.searchBy && !this.form1.search) {
      this.searchRequired = true;
    } else {
      this.searchRequired = false;

    }
  }
  onSubmitFilter(filterForm, form) {    

    //console.log("filterForm", filterForm);
    //console.log("hi !!!");
    var fdate = filterForm.startDate;
    var ldate = filterForm.endDate;
    var cdate = filterForm.currentDate;
    cdate = formatDate(Date.now(), 'yyyy-MM-dd', 'en-US', '+0530');

    if (typeof fdate === 'undefined' || fdate == null)
      fdate = "";
    else
      fdate = formatDate(filterForm.startDate, 'yyyy-MM-dd', 'en-US', '+0530');
    if (typeof ldate === 'undefined' || ldate == null)
      ldate = "";
    else
      ldate = formatDate(filterForm.endDate, 'yyyy-MM-dd', 'en-US', '+0530');
    var param = filterForm.searchBy
    
    //console.log("-------param----------", param)
    // var param = filterForm.search
    if (typeof param === 'undefined' || param == null)
      param = "";

    var filterType
    if (filterForm.searchBy)
      filterType = filterForm.searchBy;

    if (filterForm.searchBy1)
      param = filterForm.searchBy1;
    //console.log("-------param-----srch1-----", param)

    if (filterForm.search)
      param = filterForm.search;
    //console.log("-------param----srch------", param)

    var difference_in_Time = new Date(ldate).getTime() - new Date(fdate).getTime()
    var difference_in_Days = difference_in_Time / (1000 * 3600 * 24)
    //console.log("difference_in_Timedifference_in_Time in days", difference_in_Time)

    if (fdate != "" && ldate == "") {
      ldate = cdate
    }

    this.data = {

      "Start_Date": fdate,
      "End_Date": ldate,
      "filterType": filterType,
      "param": param,
      "EntityID": this.entityId

    }

    if (fdate == "" && ldate == "" && param == "") {
      this.$modal.errorModal({
        title: 'Error',
        msg: 'Please select any option'
      });
    }
    else if (fdate == "" && ldate != "") {
      this.$modal.errorModal({
        title: 'Error',
        msg: 'Please select Start date'
      });
    }
    else if (fdate > ldate) {
      this.$modal.errorModal({
        title: 'Error',
        msg: 'From Date cannot be after To Date'
      });
    }
    else {

      this.fetchpetmbindinglist(this.data)
    }
  }
  // onSubmitFilter(filterForm, form) {    

  //   this.fetchpetmbindinglist(this.data)
  
  // }

  fetchpetmbindinglist(data) {

      console.log("------------data---------",data)
    this.es.petmbindinglist_tmtatd(data)
      .subscribe(r => {
        console.log(r)
        // console.log("r.message[0].Chainparticipants[0].Seq,r.message[0].Chainparticipants[0].Role", r.message[0].Chainparticipants[0].Seq, r.message[0].Chainparticipants[0].Role)
        this.fetchedData = JSON.stringify(r);
        console.log("----------fetcch---------------------", this.fetchedData)
        this.dataSource = r;
        // console.log("---------datasource----------------", this.dataSource)
        this.onChangeDataSource(r);

      })
  }

  //   ApproveFn(urn){

  //     this.data={
  //       "urn":urn,
  //       "EntityID": this.entityId,
  //       "Remarks":  this.actionForm.get('comments').value,
  //       "action":'AP'
  //     }
  //     this.es.tmtatdactionforbinding(this.data)
  //       .subscribe(r => {
  //         console.log("-----------r--",r)
  //   })
  // }

  //   RejectFn(urn){    
  //     this.data={
  //       "urn":urn,
  //       "EntityID": this.entityId,
  //       "Remarks": this.actionForm.get('comments').value,
  //       "action":'RP'
  //     }
  //     this.es.tmtatdactionforbinding(this.data)
  //       .subscribe(r => {
  //         console.log("-----------r--",r)
  //   })
  //   }



  modalwithradio(final: any, validseq, action) {
    console.log("------final----------",final,action,validseq,typeof validseq)
    console.log("------showjustification:(validseq==3)?true:false,----------",((validseq==3)?true:false))
    if (action == 'A') {
      this.modalRef = this.modalService.show(PETMBindingDialogComponent);
      console.log("--------  this.modalRef---------",this.modalRef)

      this.modalRef.content.modalDataObj = {
        title: "PE TM Binding",
        msg: "Do you like to Approve the PE TM Binding",
        showRadioButton: true,
        showjustification:(validseq>=3)?true:false,
        radioOptions: ["Telemarketer/Aggregator", "Telemarketer Delivery"],
      };    

      this.modalRef.content.onClose.subscribe((result) => {

        if (result == true) {          
        
          let remarks = this.modalRef.content.remarks;
          let justification = this.modalRef.content.justification;
          console.log("------remarks----",remarks)    
          var selectedOption = this.modalRef.content.selectedOption;
          console.log("------selectedOption----",selectedOption)  

          if (selectedOption === "Telemarketer/Aggregator") {
            let nextentityid = this.modalRef.content.nextentityid;
            console.log("------nextentityid----",nextentityid)  
            this.modalRef = this.modalService.show(ModalPromptComponent);
            this.modalRef.content.modalDataObj = {
              title: "PE TM Binding",
              msg: "Do you like to Approve the PE TM Binding",
            }
            this.modalRef.content.onClose.subscribe(result => {
              if (result === true) {
                let datavalue = {
                  nextentityid: nextentityid,
                  urn: final,        
                  entityID: this.db.get(Constants.SESSSION_STORAGE,Constants.ENTITY_ID),
                  status: "AT",
                  selectedOption: selectedOption,
                  remarks: remarks,
                  justification: justification,
                  lastaction:'Approved by TM/TA',
                  IsRegApproval: (validseq>=3)?true:false                 
                };
                console.log("----------datavalue----", datavalue);

                this.es.tmtatdactionforbinding(datavalue).subscribe((r) => {
                  if (r.status == "success") {                
                    this.$modal.successModal({
                      title: "PE TM Binding",
                      msg: "PE TM Binding chain has been approved by " + selectedOption,
                    });
                    // this.router.navigateByUrl('/petmbindinglist-tmtatdlist');
                    this.fetchpetmbindinglist(this.data)

                  } else {
                    this.$modal.errorModal({
                      title: "PE TM Binding",
                      msg: r.message,
                    });
                  }
                });
              }
            })

          } else if (selectedOption === "Telemarketer Delivery") {

            this.modalRef = this.modalService.show(ModalPromptComponent);
            this.modalRef.content.modalDataObj = {
              title: "PE TM Binding",
              msg: "Do you like to Approve the PE TM Binding",
            }
            this.modalRef.content.onClose.subscribe(result => {
              if (result === true) {
                let datavalue = {
                  urn: final,
                  entityID: this.db.get(Constants.SESSSION_STORAGE,Constants.ENTITY_ID),
                  status: "AD",
                  selectedOption: selectedOption,
                  remarks: remarks,  
                  lastaction:'Approved by TD',
                  IsRegApproval: (validseq>=3)?true:false          
                };
              

                this.es.tmtatdactionforbinding(datavalue).subscribe((r) => {
                  if (r.status == "success") {
                    this.$modal.successModal({
                      title: "PE TM Binding",
                      msg: "PE TM Binding chain has been approved by " + selectedOption,
                    });
                    this.fetchpetmbindinglist(this.data)

                  } else {
                    this.$modal.errorModal({
                      title: "PE TM Binding",
                      msg: r.message,

                    });
                  }
                });
              }

            })
          }

        }
      });
    }
    else {

      this.modalRef = this.modalService.show(PETMBindingDialogComponent);
      this.modalRef.content.modalDataObj = {
        title: "PE TM Binding",
        msg: "Do you like to Reject the PE TM Binding",
        showRadioButton: false,
        showjustification:false,
        // radioOptions: ["Telemarketer/Aggregator", "Telemarketer Delivery"],

      };
      // const selectedOption = this.modalRef.content.selectedOption;

      this.modalRef.content.onClose.subscribe((result) => {

        if (result == true) {       
          let remarks = this.modalRef.content.remarks;

          this.modalRef = this.modalService.show(ModalPromptComponent);
          this.modalRef.content.modalDataObj = {
            title: "PE TM Binding",
            msg: "Do you like to Reject the PE TM Binding",
          }
          this.modalRef.content.onClose.subscribe(result => {
            if (result === true) {

          let datavalue = {
            //nextentityid:nextentityid,
            urn: final,            
            entityID: this.db.get(Constants.SESSSION_STORAGE,Constants.ENTITY_ID),
            status: "RT",
            // selectedOption: selectedOption,
            remarks: remarks,
            lastaction:'Rejected by TM',
            IsRegApproval: false
          };
          this.es.tmtatdactionforbinding(datavalue).subscribe((r) => {
            if (r.status == "success") {
              this.$modal.successModal({
                title: "PE TM Binding",
                msg: "PE TM Binding chain has been rejected by TM/TA/TD",
              });
              this.fetchpetmbindinglist(this.data)

            } else {
              this.$modal.errorModal({
                title: "PE TM Binding",
                msg: r.message,
              });
            }
          });
        }
      })
        }
      })

    }
  }

  openDropdown(value) {
    this.showStatusDropdown = false
    if (value == "Status") {
      this.showStatusDropdown = true;
    }
  }
  downloadtmtatdList() {

    var fileName;
    const currentdate = formatDate(now, 'medium', 'en-US', '+0530');
    console.log("-------------this.data-----",this.data)
    this.es.exportmtatdList(this.data).subscribe(r => {
      fileName = currentdate + '_'+this.entityId + '_TMTATDList.csv';
      console.log("--------------fileName--------",fileName, r)
      importedSaveAs(r, fileName)
      this.$modal.successModal({
        title: 'PE TM Binding List',
        msg: 'File has been downloaded Successfully'
      });
    })

  }
  resetValue() {
    this.data = {

      "Start_Date": '',
      "End_Date": '',
      "filterType": '',
      "param": '' ,
      "EntityID": this.db.get(Constants.SESSSION_STORAGE,Constants.ENTITY_ID),   

    }
    this.form1.searchBy1 = null
    this.fetchpetmbindinglist(this.data);
  }
}